import { SORT_CONTACTS } from '../types'

export function doSort(field, direction) {
  return {
    type: SORT_CONTACTS,
    payload: { field, direction },
  }
}
